import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import template from './change-subscription.vue';
import { Action } from '@/store';
import { ModalState, Subscription } from '@/definitions';
import apiService from '@/services/api.service';
import { moneySeperator } from '@/utilities';
import { LocalUser } from '@/store/store.definitions';

@Component({
  mixins: [template],
})
export default class ChangeSubscription extends Vue {
  selectedType: number = 1;
  userAmount: number = 0;

  async created() {
    if (this.user.isAdmin) {
      const users = await apiService.getUsers();
      this.userAmount = users.length;
    }
  }

  get user(): LocalUser {
    return this.$Store.state.user;
  }

  getMoneyString(amount: number): string {
    return `€ ${moneySeperator(amount.toString(), this.$i18n.locale)}`;
  }

  selectSubscriptionType(type: number) {
    if (type === 1 && this.userAmount <= 9) {
      this.selectedType = type;
    } else if (type === 2 && this.userAmount <= 29) {
      this.selectedType = type;
    } else if (type === 3) {
      this.selectedType = type;
    }
  }

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  get activeSubs(): boolean {
    return !!this.modal.props.subscriptions.filter((s: Subscription) => s.status === 'active').length;
  }

  async change() {
    const activeSubs = this.modal.props.subscriptions.filter((s: Subscription) => s.status === 'active');
    if (this.modal.props.subscriptions.length && (!activeSubs.length || (activeSubs.length && activeSubs[0].metadata.subscriptionType !== this.selectedType))) {
      try {
        await apiService.changeSubscription(this.selectedType);
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.payments.change_success', type: 'success' });
        this.closeModal();
      } catch (e) {
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.payments.change_error', type: 'danger' });
      }
    } else {
      this.closeModal();
    }
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }
}